import { DELETE_CHILDREN_FROM_REQUEST } from "../../../../enums/Request/request.types";

export const deleteChildrenAction = (data) => {
    return {
        type: DELETE_CHILDREN_FROM_REQUEST,
        payload: data,
    };
};
